export default __webpack_public_path__ + "static/media/carousel_1.05a54c77.svg";